import React, { useState, useEffect, useMemo } from 'react';
import { ButtonHLPure, InputHLPure, TextAreaHLPure, DropDownBtnHLPure } from '../../pures';
import SelectableListPure from '../../pures/selectable-list/selectable-list.pure';
import { useTranslation } from "react-i18next";
import { Container, Grid } from '@material-ui/core';
import moment from 'moment';

const GroupAdministrationAddView = (props) => {
    let {
        backGrid,
        action,
        createPermission,
        selectedPermission,
        editPermission,
        toggleDialogDeletePermission,
        usersByPermission,
        loadingUsers,
        users,
        getUsersByPermission
    } = props

    const { t } = useTranslation();
    const { t: tCommon } = useTranslation('common');

    const [name, setName] = useState('')
    const [description, setDescription] = useState('')
    const [createdAt, setCreatedAt] = useState('')
    const [updatedByLabel, setUpdatedByLabel] = useState('')
    const [nameDisable, setNameDisable] = useState(false)
    const [selectedAvailableUsers, setSelectedAvailableUsers] = useState([])
    const [selectedAssignedUsers, setSelectedAssignedUsers] = useState([])

    // Filtrar usuarios disponibles excluyendo los ya asignados
    const availableUsers = useMemo(() => {
        if (!users || !usersByPermission) return users || [];
        const assignedIds = usersByPermission.map(u => u.id);
        return users.filter(user => !assignedIds.includes(user.id));
    }, [users, usersByPermission]);

    useEffect(() => {
        if (action !== tCommon('details') || !selectedPermission) return;
        const modifiedBy = selectedPermission.updatedByUser ? `por ${selectedPermission.updatedByUser}` : '';
        const modifiedDate = selectedPermission.updatedDate ? `el ${selectedPermission.updatedDate}` : '';
        let labelUpdatedBy = `Modificado ${modifiedBy} ${modifiedDate}`
        setUpdatedByLabel(labelUpdatedBy)
    }, [selectedPermission, t, tCommon, action]);

    // Efecto solo para inicializar valores
    useEffect(() => {
        if (action !== tCommon('details') || !selectedPermission) return;
        setName(selectedPermission.name);
        setDescription(selectedPermission.description);
        setCreatedAt(moment(selectedPermission.createdDate).format('YYYY-MM-DD'));
        setNameDisable(!!selectedPermission.signers);
        getUsersByPermission(selectedPermission.id)
    }, [selectedPermission, action, tCommon]);

    const handleChangeName = (e) => {
        setName(e.target.value)
    }

        const handleChangeDate = (e) => {
        setCreatedAt(e.target.value)
    }

    const handleDescription = (e) => {
        setDescription(e.target.value)
    }

    const handleSubmit = () => {
        let data = {}
        data.name = name
        data.description = description
        data.usersToAdd = selectedAvailableUsers
        data.usersToRemove = selectedAssignedUsers
        if (action === t("groupAdministrationView.newGroup")) {
            createPermission(data)
        } else {
            data.id = selectedPermission.id
            data.clientId = selectedPermission.clientId
            editPermission(data)
        }
    }

    return (
        <Container disableGutters maxWidth="md">
            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <InputHLPure
                        labelInput={t("groupAdministrationAddGroupView.name")}
                        typeInput={"text"}
                        valueInput={name}
                        tooltipShow
                        positionTooltip={"right"}
                        titleTooltip={t("groupAdministrationAddGroupView.name.tooltip")}
                        descriptionTooltip={t("groupAdministrationAddGroupView.name.description")}
                        handleChangeInput={(e) => handleChangeName(e)}
                        informationIcon={true}
                        inputActive={true}
                        disabled={nameDisable ? true : false}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextAreaHLPure
                        labelTextArea={t("groupAdministrationAddGroupView.description")}
                        valueTextData={description}
                        positionTooltip={"right"}
                        handleChangeTextArea={(e) => handleDescription(e)}
                    />
                </Grid>
                {action === tCommon('details') && <>
                <Grid item xs={12} md={6}>
                    <SelectableListPure
                        items={availableUsers}
                        value={selectedAvailableUsers}
                        onSelectionChange={setSelectedAvailableUsers}
                        multiple
                        loading={loadingUsers}
                        label={t("groupAdministrationAddGroupView.users")}
                        emptyMessage={t("groupAdministrationAddGroupView.users.empty") || "No hay usuarios disponibles"}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <SelectableListPure
                        items={usersByPermission}
                        value={selectedAssignedUsers}
                        onSelectionChange={setSelectedAssignedUsers}
                        multiple
                        loading={loadingUsers}
                        label={t("groupAdministrationAddGroupView.usersAsigned")}
                        emptyMessage={t("groupAdministrationAddGroupView.usersAsigned.empty") || "No hay usuarios asignados a este grupo"}
                    />
                </Grid>
                </>}
                {
                    action === tCommon('details') &&
                    <Grid item xs={12} className='configurationDomainsAddDomain-container-label-updatedBy'>
                        <span>{updatedByLabel}</span>
                    </Grid>
                }
                <Grid item xs={12} className='button-actions'>
                    <ButtonHLPure
                        nameBtn={t("button.cancel")}
                        outlined colorScheme={"error"}
                        onClick={backGrid}
                    />

                    {
                        action === tCommon('details') &&
                        <ButtonHLPure
                            nameBtn={t("button.delete")}
                            colorScheme={"error"}
                            onClick={() => toggleDialogDeletePermission(true)}
                        />
                    }

                    <ButtonHLPure
                        nameBtn={t("button.save")}
                        primary
                        onClick={handleSubmit}
                    />
                </Grid>
            </Grid>
        </Container>
    )
}

export { GroupAdministrationAddView as default };
